<template>
  <v-expansion-panel
    v-if="permissions.length"
    v-model="expandedIndex"
    class="elevation-0"
    data-cy="permissions-expansion-panel"
  >
    <v-expansion-panel-content>
      <div slot="header">
        {{ $t('permissions') }}
      </div>
      <v-card class="grey2 lighten-4">
        <v-card-text>
          <div
            v-for="(permission, index) in permissions"
            :key="index"
            style="list-style-type: none"
          >
            <v-layout>
              <v-icon
                v-if="permission.icon"
                medium
                class="msr--text mr-4"
              >
                {{ permission.icon }}
              </v-icon>
              <div>
                <span v-if="permission.text">{{ permission.text }}</span>
                <span
                  v-if="permission.highlight"
                  class="msr--text"
                >{{
                  permission.highlight
                }}</span>
              </div>
            </v-layout>
            <v-divider
              v-if="index !== permissions.length - 1"
              class="mt-2 mb-2"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  props: {
    /* A list of objects with attributes like: icon, text, highlight */
    permissions: {
      type: Array[Object],
      required: true,
    },
  },
  data() {
    return {
      expandedIndex: -1,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Permissions.vue